export const fields = {
    COURSES: [
        { field: 'QP Framework', datatype: 'string', required: true, regex: null, dataDescription: 'string (Ex: abcd)', patternDescription: '' },
        { field: 'QP Course', datatype: 'string', required: true, regex: null, dataDescription: 'string (Ex: abcd)', patternDescription: '' },
        { field: 'QP', datatype: 'string', required: true, regex: null, dataDescription: 'string (Ex: abcd)', patternDescription: '' },
    ],
    BUSINESS_VERTICAL: [
        { field: 'id', datatype: 'number', required: true, regex: null, dataDescription: 'number (Ex: 1234)', patternDescription: '' },
        { field: 'name', datatype: 'string', required: true, regex: null, dataDescription: 'text (Ex: sample12^&@;', patternDescription: '' },
        { field: 'code', datatype: 'string', required: true, regex: null, dataDescription: 'text (Ex: sample12^&@;', patternDescription: '' },
        { field: 'description', datatype: 'string', required: false, regex: null, dataDescription: 'text (Ex: sample12^&@;', patternDescription: '' },
    ],
    // RATE_MASTER: [
    //     { "field": "id", "datatype": "number", "required": true, "regex": null, "dataDescription": "number (Ex: 1234)", "patternDescription": "" },
    //     { "field": "customer_id", "datatype": "number", "required": true, "regex": null, "dataDescription": "number (Ex: 1234)", "patternDescription": "" },
    //     { "field": "service", "datatype": "string", "required": true, "regex": null, "dataDescription": "text (Ex: Sample Service)", "patternDescription": "" },
    //     { "field": "unit_rate", "datatype": "number", "required": true, "regex": null, "dataDescription": "decimal or integer (Ex: 100.50 or 100)", "patternDescription": "" },
    //     { "field": "threshold_unit", "datatype": "number", "required": true, "regex": null, "dataDescription": "integer (Ex: 10)", "patternDescription": "" },
    //     { "field": "variable_fee", "datatype": "number", "required": true, "regex": null, "dataDescription": "decimal or integer (Ex: 50.75 or 50)", "patternDescription": "" }
    // ]
    
    
    PROJECT: [
       // { field: 'id', datatype: 'number', required: true, regex: null, dataDescription: 'number (Ex: 1234)', patternDescription: '' },
        { field: 'alias', datatype: 'text', required: true, regex: null, dataDescription: 'text (Ex: sample12^&@;', patternDescription: '' },
        { field: 'short_name', datatype: 'text', required: true, regex: null, dataDescription: 'text (Ex: sample12^&@;', patternDescription: '' },
        { field: 'project-description', datatype: 'text', required: false, regex: null, dataDescription: 'text (Ex: sample12^&@;', patternDescription: '' },
        { field: 'project-tags', datatype: 'text', required: false, regex: null, dataDescription: 'json (Ex: {"Course": ["Test", "Test 3"]}', patternDescription: '' },
    ],
    USERS: [
       // { field: 'id', datatype: 'number', required: true, regex: null, dataDescription: 'number (Ex: 1234)', patternDescription: '' },
        { field: 'full_name', datatype: 'text', required: true, regex: null, dataDescription: 'text (Ex: sample)', patternDescription: '' },
        { field: 'phone', datatype: 'integer', required: false, regex: null, dataDescription: 'text (Ex: 9999999999)', patternDescription: '' },
        { field: 'email', datatype: 'text', required: true, regex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, dataDescription: 'text (Ex: xyz@gmail.com)', patternDescription: 'text (Ex: xyz@gmail.com)' },
    ],
   CANDIDATES: [
        // { field: 'id', datatype: 'number', required: true, regex: null, dataDescription: 'number (Ex: 1234)', patternDescription: '' },
        { field: 'full_name', datatype: 'text', required: true, regex: null, dataDescription: 'text (Ex: sample)', patternDescription: '' },
        { field: 'pincode', datatype: 'integer', required: false, regex: null, dataDescription: 'text (Ex: 560062)', patternDescription: '' },
        { field: 'district', datatype: 'text', required: false, regex: null, dataDescription: 'text (Ex: Bengaluru)', patternDescription: '' },
        { field: 'state', datatype: 'text', required: false, regex: null, dataDescription: 'text (Ex: Karnataka)', patternDescription: '' },
        { field: 'email', datatype: 'text', required: false, regex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, dataDescription: 'text (Ex: xyz@gmail.com)', patternDescription: 'text (Ex: xyz@gmail.com)' },
        { field: 'phone', datatype: 'integer', required: false, regex: null, dataDescription: 'text (Ex: 9999999999)', patternDescription: '' },
    ],
    QUESTION_BANK: [
        //{ field: "id", datatype: "integer", required: true, regex: null,dataDescription: "integer (Auto-generated ID)", patternDescription: "" },
        { field: "title", datatype: "text", required: true, regex: null,dataDescription: "string (Ex: Sample Title)", patternDescription: "" },
        { field: "course_framework", datatype: "text", required: true, regex: null,dataDescription: "integer (Ex: 1)", patternDescription: "" },
        { field: "course_version", datatype: "text", required: true, regex: null,dataDescription: "integer (Ex: 2)", patternDescription: "" },
        { field: "course", datatype: "text", required: true, regex: null,dataDescription: "integer (Auto-generated ID)", patternDescription: "" },

    ],
    QUESTION_PAPERS: [
      { field: "Course/Job Role", datatype: "text", required: true, regex: null, dataDescription: "string", patternDescription: "Only numeric characters allowed" },
      { field: "Course Code", datatype: "text", required: false, regex: null, dataDescription: "string", patternDescription: "Only numeric characters allowed" },
      { field: "Course Version", datatype: "text", required: true, regex: null, dataDescription: "string", patternDescription: "Only numeric characters allowed" },
      { field: "Question Id", datatype: "integer", required: true, regex: null, dataDescription: "integer (Ex: 123)", patternDescription: "" },
      { field: "Language", datatype: "text", required: true, regex: "^[A-Za-z]+$", dataDescription: "string (Ex: English, Spanish)", patternDescription: "Only alphabetic characters" },
      { field: "Question Text", datatype: "text", required: true, regex: null, dataDescription: "string (Ex: What is 2+2?)", patternDescription: "" },
      { field: "Evaluation Mode", datatype: "text", required: true, regex: null, dataDescription: "", patternDescription: "Must be a type in the dropdown" },
      { field: "Difficulty Level", datatype: "text", required: true, regex: "", dataDescription: "string (Ex: easy, medium, hard)", patternDescription: "" },
      { field: "Kpi Name", datatype: "text", required: false, regex: null, dataDescription: "string (Ex: DI:t+L01C&)", patternDescription: "" },
      { field: "Viva Score", datatype: "float", required: false, regex: "^[0-9]+(\\.[0-9]+)?$", dataDescription: "float (Ex: 61.59)", patternDescription: "Decimal number allowed" },
      { field: "Observation Score", datatype: "float", required: false, regex: "^[0-9]+(\\.[0-9]+)?$", dataDescription: "float (Ex: 39.07)", patternDescription: "Decimal number allowed" },
      { field: "Kpi Score", datatype: "float", required: false, regex: "^[0-9]+(\\.[0-9]+)?$", dataDescription: "float (Ex: 4.77)", patternDescription: "Decimal number allowed" }
    ],

  CUSTOMER_MASTER: [
    { field: 'Customer Name', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: ABC Corp)', patternDescription: '' },
    { field: 'Business Vertical', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: IT)', patternDescription: '' },
    { field: 'Industry Vertical', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: Healthcare)', patternDescription: '' },
    { field: 'GSTIN', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: 33ABCDE1234F1Z5)', patternDescription: '' },
    { field: 'PAN', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: ABCDE1234F)', patternDescription: '' },
    { field: 'Address', datatype: 'text', required: true, regex: null, dataDescription: 'string', patternDescription: '' },
    { field: 'Is Pin Code Applicable', datatype: 'text', required: true, regex: null, dataDescription: 'Yes or No', patternDescription: '' },
    { field: 'Pincode', datatype: 'text', required: false, regex: null, dataDescription: 'number (Ex: 613005)', patternDescription: '' },
    { field: 'State', datatype: 'text', required: false, regex: null, dataDescription: 'string (Ex: Karnataka)', patternDescription: '' },
    { field: 'District', datatype: 'text', required: false, regex: null, dataDescription: 'string (Ex: Bengaluru)', patternDescription: '' },
    { field: 'Logo', datatype: 'text', required: false, regex: null, dataDescription: 'string (URL)', patternDescription: '' },
  ],

  LEAD_MASTER: [
    { field: 'Lead Name', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: Lead A)', patternDescription: '' },
    { field: 'Business Vertical', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: IT)', patternDescription: '' },
    { field: 'Industry Vertical', datatype: 'text', required: false, regex: null, dataDescription: 'string', patternDescription: '' },
    { field: 'Lead Address', datatype: 'text', required: false, regex: null, dataDescription: 'string', patternDescription: '' },
    { field: 'Is Pin Code Applicable', datatype: 'text', required: true, regex: null, dataDescription: 'Yes or No', patternDescription: '' },
    { field: 'Pincode', datatype: 'text', required: false, regex: null, dataDescription: 'number (Ex: 613005)', patternDescription: '' },
    { field: 'State', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: Karnataka)', patternDescription: '' },
    { field: 'District', datatype: 'text', required: true, regex: null, dataDescription: 'string (Ex: Bengaluru)', patternDescription: '' },
    { field: 'Estimated Revenue', datatype: 'integer', required: false, regex: null, dataDescription: 'number (Ex: 50000)', patternDescription: '' },
    { field: 'Estimated Units', datatype: 'integer', required: false, regex: null, dataDescription: 'number (Ex: 10)', patternDescription: '' },
    { field: 'Tags', datatype: 'text', required: false, regex: null, dataDescription: 'text (Ex: fathername-mani)', patternDescription: '' }
  ],


    
 QUESTIONS : [
    {
    field: "Course/Job Role",
    datatype: "text",
    required: true,
    regex: null,
    dataDescription: "string",
    patternDescription: "Only numeric characters allowed"
  },
  {
    field: "Course Code",
    datatype: "text",
    required: false,
    regex: null,
    dataDescription: "string",
    patternDescription: "Only numeric characters allowed"
  },
    {
    field: "Course Version",
    datatype: "text",
    required: true,
    regex: null,
    dataDescription: "string",
    patternDescription: "Only numeric characters allowed"
  },
      {
    field: "Question Id",
    datatype: "integer",
    required: true,
    regex: null,
    dataDescription: "integer (Ex: 123)",
    patternDescription: ""
  },
  {
    field: "Language",
    datatype: "text", // change to integer if you use language_id instead
    required: true,
    regex: "^[A-Za-z]+$",
    dataDescription: "string (Ex: English, Spanish)",
    patternDescription: "Only alphabetic characters"
  },
  {
    field: "Question Text",
    datatype: "text",
    required: true,
    regex: null,
    dataDescription: "string (Ex: What is 2+2?)",
    patternDescription: ""
  },
  {
    field: "Evaluation Mode",
    datatype: "text",
    required: true,
    regex: "^[A-Za-z0-9]+$",
    dataDescription: "",
    patternDescription: "Must be a type in the dropdown"
  },
  {
    field: "Difficulty Level",
    datatype: "text",
    required: true,
    regex: "",
    dataDescription: "string (Ex: easy, medium, hard)",
    patternDescription: ""
  },
  {
    field: "Kpi Name",
    datatype: "text",
    required: false,
    regex: null,
    dataDescription: "string (Ex: DI:t+L01C&)",
    patternDescription: ""
  },
  {
    field: "Viva Score",
    datatype: "float",
    required: false,
    regex: "^[0-9]+(\\.[0-9]+)?$",
    dataDescription: "float (Ex: 61.59)",
    patternDescription: "Decimal number allowed"
  },
  {
    field: "Observation Score",
    datatype: "float",
    required: false,
    regex: "^[0-9]+(\\.[0-9]+)?$",
    dataDescription: "float (Ex: 39.07)",
    patternDescription: "Decimal number allowed"
  },
  {
    field: "Kpi Score",
    datatype: "float",
    required: false,
    regex: "^[0-9]+(\\.[0-9]+)?$",
    dataDescription: "float (Ex: 4.77)",
    patternDescription: "Decimal number allowed"
  }
],
QUESTION_UPDATE: [
  { field: "Question Id", datatype: "integer",  required: true, regex: null, dataDescription: "integer (Ex: 123)", patternDescription: ""},
  { field: "Question Text", datatype: "text", required: true, regex: null, dataDescription: "string (Ex: What is 2+2?)", patternDescription: "" },
  { field: "Difficulty Level", datatype: "text", required: true, regex: "", dataDescription: "string (Ex: easy, medium, hard)", patternDescription: "" },
  { field: "NOS List", datatype: "text", required: true, regex: null, dataDescription: "", patternDescription: "" },
  { field: "NOS Element", datatype: "text", required: false, regex: null, dataDescription: "", patternDescription: "" },
  // { field: "PC List", datatype: "text", required: false, regex: null, dataDescription: "", patternDescription: "" }
  ]
        
}

